export default "__VITE_ASSET__DJscK0Gh__"